import { CropIcon } from '@cw-elements/crop-icons';
import { COLOR_OPTIONS } from 'config/style';
import STTypo, { STTypoModels } from 'core/shared/typo';
import dayjs from 'dayjs';
import type { RegionalOverviewV2Properties } from 'querys/regional-overview/regional-overview.query.models';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { wkSlugToCropIconName } from '@features/regional-overview/utils';

interface IRegionalRiskPopup {
  properties: RegionalOverviewV2Properties;
}

const RegionalRiskPopup: React.FC<IRegionalRiskPopup> = ({ properties }) => {
  const [t] = useTranslation();
  return (
    <div className='sd-regional-risk-popup'>
      <div className='sd-regional-risk-popup__header'>
        <div className='sd-regional-risk-popup__header-line'>
          <STTypo type={STTypoModels.TypeOptions.H5} color={COLOR_OPTIONS.PRIMARY} fontWeight={500}>
            {properties.name}
          </STTypo>
        </div>
        <div className='sd-regional-risk-popup__header-line'>
          <STTypo type={STTypoModels.TypeOptions.P2} color={COLOR_OPTIONS.SECONDARY}>
            {properties.values.property_name}
          </STTypo>
        </div>
        <div className='sd-regional-risk-popup__header-icon'>
          <CropIcon iconName={wkSlugToCropIconName(properties.values?.crop_name)} />
        </div>
      </div>
      <div className='sd-regional-risk-popup__body'>
        <div className='sd-regional-risk-popup__header-line'>
          <STTypo type={STTypoModels.TypeOptions.P2} color={COLOR_OPTIONS.PRIMARY}>
            {t('pages.regional_overview.regional_risk.variety')}
          </STTypo>
        </div>
        <div className='sd-regional-risk-popup__header-line'>
          <STTypo type={STTypoModels.TypeOptions.P2} color={COLOR_OPTIONS.SECONDARY}>
            {properties.values.variety_name}
          </STTypo>
        </div>
        <br />
        <div className='sd-regional-risk-popup__header-line'>
          <STTypo type={STTypoModels.TypeOptions.P2} color={COLOR_OPTIONS.PRIMARY}>
            {t('pages.regional_overview.regional_risk.sowing_date')}
          </STTypo>
        </div>
        <div className='sd-regional-risk-popup__header-line'>
          <STTypo type={STTypoModels.TypeOptions.P2} color={COLOR_OPTIONS.SECONDARY}>
            {properties.values.planting_date ? dayjs(properties.values.planting_date).format('LL') : '-'}
          </STTypo>
        </div>
      </div>
    </div>
  );
};

export default RegionalRiskPopup;
